import { render } from "./property-info.vue?vue&type=template&id=1e6c1434&scoped=true&ts=true"
import script from "./property-info.vue?vue&type=script&lang=ts"
export * from "./property-info.vue?vue&type=script&lang=ts"

import "./property-info.vue?vue&type=style&index=0&id=1e6c1434&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6c1434"]])

export default __exports__